import React, { Component } from 'react';
import ImageBackground from '../common/imageBackground';
import ImageHeader from '../common/imageHeader';
import ImageButtonList from '../common/imageButtonList';
import PatientBanner from '../common/patientBanner';
import NavigationBar from '../common/navigationBar';
import './styles.css';

export default class TimeDisplay extends Component {
  /**
   * The component's current state.
   *
   * @property {object}  state
   * @public
   *
   **/
  state = {
    timeImages: null,
    currentTime: null
  };
  buttonList = {
    top: 263,
    left: 838
  };
  button = {
    id: 'time',
    to: '/sleep_timer/confirm/',
    unhighlight: null,
    alt: 'Time'
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will create the initial list of buttons.
   *
   * @protected
   *
   **/
  componentWillMount() {
    this.setState({
      currentTime: this.props.match.params.current || 2,
      timeImages: this.props.timeList
    });
    document.addEventListener('keyup', this.handleOnKeyUp.bind(this), false);
  }

  handleOnKeyUp(event) {
    switch (event.key) {
      case 'ArrowDown':
        this.decreaseTime();
        break;
      case 'ArrowUp':
        this.increaseTime();
        break;
      default:
    }
  }

  handleUpArrow = event => {
    this.increaseTime();
  };

  handleDownArrow = event => {
    this.decreaseTime();
  };

  increaseTime() {
    let current = null;

    current = parseInt(this.state.currentTime, 10) + 1;
    if (current >= this.state.timeImages.length - 1) {
      current = this.state.timeImages.length - 1;
    }
    this.setState({
      currentTime: current
    });
  }

  decreaseTime() {
    let current = null;

    current = parseInt(this.state.currentTime, 10) - 1;
    if (current <= 0) {
      current = 0;
    }
    this.setState({
      currentTime: current
    });
    return current;
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/

  render() {
    this.button.unhighlight = this.state.timeImages[parseInt(this.state.currentTime, 10)];
    this.button.to = '/sleep_timer/confirm/' + this.state.currentTime;
    var buttons = [this.button];
    return (
      <div>
        <ImageBackground id="background" />
        <PatientBanner {...this.props.banner} />
        <ImageHeader {...this.props.header} />
        <NavigationBar {...this.props.navigationBar} />
        <ImageButtonList {...this.buttonList} imageButtons={buttons} />
        <img src={require('./images/TimeRemaining_45.png')} className="time-remaining" alt="" />
        <img src={this.props.arrows.up} className="arrow-up" onClick={this.handleUpArrow} alt="" />
        <img src={this.props.arrows.down} className="arrow-down" onClick={this.handleDownArrow} alt="" />
      </div>
    );
  }
}
